module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "mobile-width pull-left pagetitleText ml-2 mb-2 mt-3",
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h5', [_c('b', [_vm._v("All Vehicles History List")])])])], 1), _vm._v(" "), _c('md-card', {
    staticClass: "card"
  }, [_c('md-card-content', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Vehicle No. / Series / Approval / Complain"
    },
    model: {
      value: (_vm.vehicleHistoryfilter),
      callback: function($$v) {
        _vm.vehicleHistoryfilter = $$v
      },
      expression: "vehicleHistoryfilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.vehicleHistoryfilter
    },
    on: {
      "click": function($event) {
        _vm.vehicleHistoryfilter = ''
      }
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.showVehicleHistory('Excel')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.ExcelBtnName) + "\n                      "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRowsVehicleHistory) + " History Entries")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.vehicleHistoryList,
      "fields": _vm.vehicleHistoryFields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPageVehicleHistory,
      "filter": _vm.vehicleHistoryfilter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onvehicleHistoryFiltered
    },
    scopedSlots: _vm._u([{
      key: "vehicleId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPageVehicleHistory))])]
      }
    }, {
      key: "vehicleNo",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.vehicleNo))])]
      }
    }, {
      key: "serviceEstSeries",
      fn: function(row2) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewRequiredItemList(row2.item.itemForServiceEstId, row2.item.vehicleNo, row2.item.serviceEstDate)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(row2.item.serviceEstSeries) + "\n                  ")])]
      }
    }, {
      key: "driverName",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.driverName))])]
      }
    }, {
      key: "estimationDate",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.serviceEstDate))])]
      }
    }, {
      key: "odometreReading",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.odometre_Reading) + " "), (row5.item.odometre_Reading != null) ? _c('small', [_vm._v(" km")]) : _vm._e()])]
      }
    }, {
      key: "driverComplain",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.driver_complain))])]
      }
    }, {
      key: "approvedStatus",
      fn: function(row7) {
        return [(row7.item.approvedStatus == 'Approved') ? _c('span', {
          staticClass: "success"
        }, [_vm._v(_vm._s(row7.item.approvedStatus))]) : _c('span', {
          staticClass: "error"
        }, [_vm._v(_vm._s(row7.item.approvedStatus))])]
      }
    }, {
      key: "approvedBy",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.approvedBy))])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRowsVehicleHistory,
      "per-page": _vm.perPageVehicleHistory
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "required-item-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "title": "Aproval / Rejection of Required Items",
      "centered": ""
    }
  }, [_c('large', {
    staticClass: "pull-right mr-2 mb-2"
  }, [_vm._v(" Vehicle No.: "), _c('b', {
    staticClass: "warning"
  }, [_vm._v(_vm._s(_vm.vehicleNo))])]), _vm._v(" "), _c('large', {
    staticClass: "pull-right mr-2 mb-2"
  }, [_c('b', [_vm._v("|")])]), _vm._v(" "), _c('large', {
    staticClass: "pull-right mr-2 mb-2"
  }, [_vm._v(" Estimation Date: "), _c('b', {
    staticClass: "warning"
  }, [_vm._v(_vm._s(_vm.serviceEstDate))])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.itemServiceDetails,
      "fields": _vm.itemServiceDetailsFields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPageItemServiceDetails,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "itemId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPageItemServiceDetails))])]
      }
    }, {
      key: "itemName",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.itemName))])]
      }
    }, {
      key: "quantity",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.quantity))])]
      }
    }, {
      key: "itemQuantity",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.itemQuantity))])]
      }
    }, {
      key: "loginTime",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.loginTime))])]
      }
    }, {
      key: "approvedStatus",
      fn: function(row5) {
        return [(row5.item.approvedStatus == 'Approved') ? _c('span', {
          staticClass: "success"
        }, [_vm._v(_vm._s(row5.item.approvedStatus))]) : _c('span', {
          staticClass: "error"
        }, [_vm._v(_vm._s(row5.item.approvedStatus))])]
      }
    }, {
      key: "approvedBy",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.approvedBy))])]
      }
    }])
  })], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7983f621","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/maintenance/vehicleServiceHistory/vehicleServiceHistory.vue
// module id = 2761
// module chunks = 0